// extracted by mini-css-extract-plugin
export default {"content":"ReviewModal_content__Q0thI","buttonsContainer":"ReviewModal_buttonsContainer__L1vcv"};